import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMail,FiPhone,FiMapPin}=FiIcons;

function Contact() {
  return (
    <section className="pt-32 pb-24 bg-gradient-to-br from-gray-50 via-white to-orange-50 relative overflow-hidden min-h-screen">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-96 h-96 bg-orange-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-red-500/5 rounded-full blur-3xl"></div>
        <div className="absolute inset-0 opacity-3">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}></div>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{y: 30,opacity: 0}}
          animate={{y: 0,opacity: 1}}
          transition={{duration: 0.8}}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center space-x-2 bg-orange-100 text-orange-600 px-6 py-2 rounded-full font-semibold mb-6">
            <span>Get In Touch</span>
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            Let's Get Started
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Ready to unlock your next best sales channel? Reach out to us today.
          </p>
        </motion.div>

        {/* Contact Information Only */}
        <motion.div
          initial={{x: -50,opacity: 0}}
          animate={{x: 0,opacity: 1}}
          transition={{duration: 0.8,delay: 0.2}}
          className="max-w-4xl mx-auto"
        >
          <motion.div
            whileHover={{y: -5}}
            className="bg-white rounded-2xl p-12 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300"
          >
            <h3 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              Get in Touch
            </h3>
            
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              <div className="text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={FiMail} className="w-8 h-8 text-orange-500" />
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Email</h4>
                <p className="text-gray-600">hello@leadspark.cc</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={FiPhone} className="w-8 h-8 text-orange-500" />
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Phone</h4>
                <p className="text-gray-600">251-235-2120</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={FiMapPin} className="w-8 h-8 text-orange-500" />
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Location</h4>
                <p className="text-gray-600">Mobile, AL</p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-4 text-center">Why LeadSpark?</h3>
              <p className="text-lg mb-6 text-center">
                We help businesses pull in multiple $1000s in extra sales without asking them to do any extra work.
              </p>
              <ul className="list-disc list-inside space-y-2 text-white/90 max-w-2xl mx-auto">
                <li>24/7 AI Sales Team</li>
                <li>Instant Lead Response</li>
                <li>Database Reactivation</li>
              </ul>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}

export default Contact;